import React from 'react';

const ProgressStepper = ({ currentStep, steps, onStepClick, showCurrentAsCompleted = false }) => {
  const getStepClass = (stepIndex) => {
    let baseClass = 'step-enhanced';
    if (stepIndex < currentStep) baseClass += ' completed';
    if (stepIndex === currentStep) {
      if (showCurrentAsCompleted) {
        baseClass += ' completed';
      } else {
        baseClass += ' active';
      }
    }
    if (stepIndex < currentStep && onStepClick) baseClass += ' clickable';
    return baseClass;
  };

  const getStepCircleContent = (stepIndex, step) => {
    if (stepIndex < currentStep || (stepIndex === currentStep && showCurrentAsCompleted)) {
      return <i className="bi bi-check-lg"></i>;
    }
    return step.number || stepIndex + 1;
  };

  const handleStepClick = (stepIndex) => {
    // Only allow clicking on completed steps (steps before current step)
    if (stepIndex < currentStep && onStepClick) {
      onStepClick(stepIndex);
    }
  };

  return (
    <div className="progress-stepper-enhanced" id="progressStepper">
      {steps.map((step, index) => (
        <div 
          key={index} 
          className={getStepClass(index)} 
          id={`step${index + 1}`}
          onClick={() => handleStepClick(index)}
          style={{ cursor: index < currentStep && onStepClick ? 'pointer' : 'default' }}
        >
          <div className="step-connector"></div>
          <div className="step-content">
            <div className="step-circle">
              {getStepCircleContent(index, step)}
            </div>
            <div className="step-info">
              <div className="step-label">{step.label}</div>
              <div className="step-description">{step.description}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgressStepper;
